"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = exports.CallbackProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _AppContext = _interopRequireDefault(require("./AppContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var initialState = {
  onCommentClick: function onCommentClick() {},
  onCommentHover: function onCommentHover() {},
  onCloseButtonClick: function onCloseButtonClick() {},
  onLogin: function onLogin() {},
  onNodeChange: function onNodeChange() {},
  onMobileCommentsListHeightChange: function onMobileCommentsListHeightChange() {},
  onAnnotationToggle: function onAnnotationToggle() {},
  onCommentsUpdate: function onCommentsUpdate() {},
  onCommentsSuccess: function onCommentsSuccess() {},
  onShare: undefined
};
exports.initialState = initialState;

var CallbackContext = /*#__PURE__*/_react.default.createContext(initialState);

var CallbackProvider = function CallbackProvider(_ref) {
  var children = _ref.children,
      onCommentClick = _ref.onCommentClick,
      onCommentHover = _ref.onCommentHover,
      onCloseButtonClick = _ref.onCloseButtonClick,
      onLogin = _ref.onLogin,
      onNodeChange = _ref.onNodeChange,
      onMobileCommentsListHeightChange = _ref.onMobileCommentsListHeightChange,
      onAnnotationToggle = _ref.onAnnotationToggle,
      onCommentsUpdate = _ref.onCommentsUpdate,
      onCommentsSuccess = _ref.onCommentsSuccess,
      onShare = _ref.onShare;

  var _useContext = (0, _react.useContext)(_AppContext.default),
      assetData = _useContext.assetData;

  var assetId = assetData === null || assetData === void 0 ? void 0 : assetData.id;
  var handleCommentClick = (0, _react.useCallback)(function (evt, commentData, hasAnnotation) {
    var _commentData$target, _commentData$target$s;

    onCommentClick(commentData.id, {
      hasAnnotation: hasAnnotation,
      selector: ".".concat(_constants.ANNOTATION_CLASS_PREFIX, "[data-annotationid=\"").concat(commentData.id, "\"]"),
      sectionId: commentData === null || commentData === void 0 ? void 0 : (_commentData$target = commentData.target) === null || _commentData$target === void 0 ? void 0 : (_commentData$target$s = _commentData$target.selector) === null || _commentData$target$s === void 0 ? void 0 : _commentData$target$s.sectionId,
      assetId: assetId
    });
  }, [assetId, onCommentClick]);
  var handleCommentHover = (0, _react.useCallback)(function (evt, commentData, isHovered, hasAnnotation) {
    var _commentData$target2, _commentData$target2$;

    onCommentHover(commentData.id, {
      isHovered: isHovered,
      hasAnnotation: hasAnnotation,
      selector: ".".concat(_constants.ANNOTATION_CLASS_PREFIX, "[data-annotationid=\"").concat(commentData.id, "\"]"),
      sectionId: commentData === null || commentData === void 0 ? void 0 : (_commentData$target2 = commentData.target) === null || _commentData$target2 === void 0 ? void 0 : (_commentData$target2$ = _commentData$target2.selector) === null || _commentData$target2$ === void 0 ? void 0 : _commentData$target2$.sectionId,
      assetId: assetId
    });
  }, [assetId, onCommentHover]);
  var handleCloseButtonClick = (0, _react.useCallback)(function () {
    onCloseButtonClick({
      assetId: assetId
    });
  }, [assetId, onCloseButtonClick]);
  var handleLogin = (0, _react.useCallback)(function (isLogin, guestInfo) {
    onLogin(isLogin, guestInfo, {
      assetId: assetId
    });
  }, [assetId, onLogin]);
  var handleNodeChange = (0, _react.useCallback)(function (nodeId, sectionId) {
    onNodeChange(nodeId, sectionId, {
      assetId: assetId
    });
  }, [assetId, onNodeChange]);
  var handleMobileCommentsListHeightChange = (0, _react.useCallback)(function (newMobileCommentsListHeight) {
    onMobileCommentsListHeightChange(newMobileCommentsListHeight, {
      assetId: assetId
    });
  }, [assetId, onMobileCommentsListHeightChange]);
  var handleAnnotationToggle = (0, _react.useCallback)(function (newToggleState) {
    onAnnotationToggle(newToggleState, {
      assetId: assetId
    });
  }, [assetId, onAnnotationToggle]);
  var handleShare = (0, _react.useCallback)(function (reviewType) {
    onShare(reviewType, {
      assetId: assetId
    });
  }, [assetId, onShare]);
  var contextValue = (0, _react.useMemo)(function () {
    return {
      onCommentClick: handleCommentClick,
      onCommentHover: handleCommentHover,
      onCloseButtonClick: handleCloseButtonClick,
      onLogin: handleLogin,
      onNodeChange: handleNodeChange,
      onMobileCommentsListHeightChange: handleMobileCommentsListHeightChange,
      onAnnotationToggle: handleAnnotationToggle,
      onShare: onShare ? handleShare : undefined,
      onCommentsUpdate: onCommentsUpdate,
      onCommentsSuccess: onCommentsSuccess
    };
  }, [handleCommentClick, handleCommentHover, handleCloseButtonClick, handleLogin, handleNodeChange, handleMobileCommentsListHeightChange, handleAnnotationToggle, handleShare, onCommentsUpdate, onCommentsSuccess, onShare]);
  return /*#__PURE__*/_react.default.createElement(CallbackContext.Provider, {
    value: contextValue
  }, children);
};

exports.CallbackProvider = CallbackProvider;
CallbackProvider.defaultProps = initialState;
CallbackProvider.propTypes = {
  children: _propTypes.default.node,
  onCommentClick: _propTypes.default.func,
  onCommentHover: _propTypes.default.func,
  onCloseButtonClick: _propTypes.default.func,
  onLogin: _propTypes.default.func,
  onNodeChange: _propTypes.default.func,
  onMobileCommentsListHeightChange: _propTypes.default.func,
  onAnnotationToggle: _propTypes.default.func,
  onCommentsUpdate: _propTypes.default.func,
  onCommentsSuccess: _propTypes.default.func,
  onShare: _propTypes.default.func
};
var _default = CallbackContext;
exports.default = _default;